module.exports = __webpack_public_path__ + "img/ic_file-not-valid.8d8e5883.svg";